import React, { useState } from "react";

import {
  TextField,
  Grid,
  Button,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  CircularProgress,
  Alert,
} from "@mui/material";

import Groups from "../components/groups.component";
import axiosClient from "../axiosClient";

import { useStateContext } from "../context/ContextProvider";

export default function GroupsScreen() {
  const [showGroupForm, setShowGroupForm] = useState(false);
  const [active, setActive] = useState("true");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [name, setName] = useState("");

  const { store } = useStateContext();

  if (loading) {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CircularProgress />
        </Grid>
      </Grid>
    );
  }

  if (showGroupForm) {
    return (
      <div>
        <Grid container direction="row" alignItems="center" spacing={2}>
          {errorMessage && (
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Alert severity="error" sx={{ marginBottom: 2 }}>
                {errorMessage}
              </Alert>
            </Grid>
          )}
        </Grid>
        <Grid container direction="row" alignItems="center" spacing={2}>
          <Grid item xs={12} sm={2} md={2} lg={2}>
            <TextField
              label="Group name"
              fullWidth
              autoFocus
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={2} md={2} lg={2}>
            <FormControl component="fieldset">
              <FormLabel component="legend">Active</FormLabel>
              <RadioGroup
                row
                value={active}
                onChange={(e) => setActive(e.target.value)}
              >
                <FormControlLabel
                  value="true"
                  control={<Radio />}
                  label="True"
                />
                <FormControlLabel
                  value="false"
                  control={<Radio />}
                  label="False"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={2} md={2} lg={2}>
            <Button
              variant="contained"
              sx={{ marginBottom: 2 }}
              color="success"
              size="small"
              onClick={() => {
                setLoading(true);
                const correctStoreName = JSON.parse(store).name.replace(
                  /[^a-zA-Z]/g,
                  ""
                );
                const databaseStoreName = `DB301_${
                  JSON.parse(store).id
                }_${correctStoreName}`;

                const payload = {
                  params: {
                    name: name,
                    display: active,
                    shopName: databaseStoreName,
                  },
                };

                axiosClient
                  .post("groups/create", payload)
                  .then(() => {
                    setLoading(false);
                    setName('')
                    setShowGroupForm(false);
                    setErrorMessage("");
                  })
                  .catch((err) => {
                    const errorMessage = err.response.data.err.errors.map(
                      (e) => {
                        return (
                          <>
                            {e.message}
                            <br></br>
                          </>
                        );
                      }
                    );
                    setLoading(false);
                    setErrorMessage(errorMessage);
                  });
              }}
            >
              Add group
            </Button>
            <Button
              variant="contained"
              sx={{ marginBottom: 2, marginLeft: 2 }}
              color="error"
              size="small"
              onClick={() => {
                setShowGroupForm(false);
                setErrorMessage("");
              }}
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      </div>
    );
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Groups setShowGroupForm={setShowGroupForm} />
      </Grid>
    </Grid>
  );
}
